import * as Immutable from "immutable";
import { DEFAULT_AXIS_CONFIG, DEFAULT_AXIS_TYPE } from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import VisualizationConfig from "views/logic/aggregationbuilder/visualizations/VisualizationConfig";
import LineVisualizationConfig from "views/logic/aggregationbuilder/visualizations/LineVisualizationConfig";
export default class ScatterVisualizationConfig extends VisualizationConfig {
  constructor(axisType = DEFAULT_AXIS_TYPE, axisConfig = DEFAULT_AXIS_CONFIG) {
    super();
    this._value = { axisType, axisConfig };
  }
  get axisType() {
    return this._value.axisType;
  }
  get axisConfig() {
    return this._value.axisConfig;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  static create(axisType, axisConfig = DEFAULT_AXIS_CONFIG) {
    return new ScatterVisualizationConfig(axisType, axisConfig);
  }
  static empty() {
    return new ScatterVisualizationConfig(DEFAULT_AXIS_TYPE, DEFAULT_AXIS_CONFIG);
  }
  toJSON() {
    const { axisType, axisConfig } = this._value;
    return {
      axis_type: axisType,
      axis_config: axisConfig
    };
  }
  static fromJSON(_type, value) {
    var _a, _b;
    return ScatterVisualizationConfig.create(
      (_a = value == null ? void 0 : value.axis_type) != null ? _a : DEFAULT_AXIS_TYPE,
      (_b = value == null ? void 0 : value.axis_config) != null ? _b : DEFAULT_AXIS_CONFIG
    );
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  axisType(value) {
    return new Builder(this.value.set("axisType", value));
  }
  build() {
    const { interpolation, axisType } = this.value.toObject();
    return new LineVisualizationConfig(interpolation, axisType);
  }
}
